import { hasGrantedAnalyticsConsent } from "./analyticsConsent";
import { isPublicAnalyticsPath } from "./analyticsPrivacy";

export type SeoEventName =
  | "seo_cta_click"
  | "signup_started"
  | "signup_completed"
  | "faceless_workflow_started"
  | "first_video_generated"
  | "subscription_started";

export type SeoEventPayload = Record<
  string,
  string | number | boolean | undefined
>;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackSeoEvent(
  eventName: SeoEventName,
  payload: SeoEventPayload = {},
) {
  if (typeof window === "undefined") return;
  if (
    !isPublicAnalyticsPath(window.location.pathname) ||
    !hasGrantedAnalyticsConsent(document.cookie)
  ) {
    return;
  }

  const allowedKeys = new Set([
    "source",
    "page",
    "location",
    "locale",
    "intent",
    "method",
    "workflow_type",
    "input_type",
    "duration_bucket",
    "aspect_ratio",
    "platform_count",
    "plan_key",
    "result_status",
    "error_category",
  ]);
  const safePayload = Object.fromEntries(
    Object.entries(payload).filter(
      ([key, value]) =>
        allowedKeys.has(key.toLowerCase()) && value !== undefined,
    ).map(([key, value]) => [
      key,
      typeof value === "string" ? value.slice(0, 100) : value,
    ]),
  );

  window.gtag?.("event", eventName, safePayload);
}
